import { createFileRoute } from "@tanstack/react-router";
import { WhiteboardPage } from "@/features/whiteboard/WhiteboardPage";

export const Route = createFileRoute("/_app/whiteboards/$id")({ component: Page });

function Page() {
  const { id } = Route.useParams();
  return <WhiteboardPage id={id} />;
}
